import { supabase } from '../config/supabase';

const BLOCKING = ['scheduled', 'dispatched', 'in_progress'] as const;

/**
 * Day-wide driver exclusivity for full-day escort trips (CONF-20260727).
 * Returns true when assignment would violate escort rules.
 */
export async function isDriverBlockedByFullDayEscort(params: {
  driverId: string;
  date: string;
  excludeTripId?: string | null;
  /** True when the trip/job being assigned is itself full-day escort. */
  assigningEscort: boolean;
}): Promise<boolean> {
  const { data, error } = await supabase.rpc('driver_blocked_by_full_day_escort', {
    p_driver_id: params.driverId,
    p_date: params.date,
    p_exclude_trip_id: params.excludeTripId ?? null,
    p_assigning_escort: params.assigningEscort,
  });
  if (error) {
    // Fallback query if RPC missing in older envs
    let q = supabase
      .from('trips')
      .select('id, driver_full_day_escort')
      .eq('driver_id', params.driverId)
      .eq('date', params.date)
      .in('status', [...BLOCKING]);
    if (params.excludeTripId) q = q.neq('id', params.excludeTripId);
    const { data: rows, error: qErr } = await q;
    if (qErr) throw new Error(qErr.message);
    const list = rows ?? [];
    if (params.assigningEscort) return list.length > 0;
    return list.some((r) => Boolean(r.driver_full_day_escort));
  }
  return Boolean(data);
}
